export enum GadgetsEnum {
  Alerts = 'Dashboard.Alerts',
  Emails = 'Dashboard.Emails',
}
